import * as Yup from 'yup';

import { EMPTY_STRING } from '@e-socna/empty';
import {
  isValidOrganizationIdentifierValue,
  isValidSiret,
  normalizeOrganizationIdentifierValue,
} from '@e-socna/third-parties';

import { ThirdPartySchema } from './third-party.schema';
import { ShareCapitalSchema } from './share-capital.schema';
import { ContactInfoSchema } from './contact-info.schema';

export const OrganizationSchema = ThirdPartySchema.shape({
  shareCapital: ShareCapitalSchema.nullable(),
  contactInfo: ContactInfoSchema.nullable(),
  identifier: Yup.object({
    value: Yup.string()
      .nullable()
      .test(
        'is-valid-siren-or-siret',
        'Le siren/siret est invalide.',
        (value) =>
          !value ||
          isValidOrganizationIdentifierValue(
            normalizeOrganizationIdentifierValue(value),
          ),
      ),
  }).when('isInternal', {
    is: true,
    then: (schema) =>
      schema.shape({
        value: Yup.string()
          .required('Le siret est requis.')
          .test('is-siret', 'Le siret est requis.', (value) =>
            isValidSiret(
              // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
              normalizeOrganizationIdentifierValue(value ?? EMPTY_STRING),
            ),
          ),
      }),
  }),
});
